export var FullscreenHelperEventType;
(function (FullscreenHelperEventType) {
    FullscreenHelperEventType["Change"] = "change";
    FullscreenHelperEventType["Error"] = "error";
})(FullscreenHelperEventType || (FullscreenHelperEventType = {}));
export class FullscreenHelper {
    constructor() {
        this.nativeAPI = null;
        this.eventNameMap = {
            [FullscreenHelperEventType.Change]: ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange'],
            [FullscreenHelperEventType.Error]: ['fullscreenerror', 'webkitfullscreenerror', 'mozfullscreenerror', 'MSFullscreenError']
        };
        this.methodMap = [
            ['requestFullscreen', 'exitFullscreen', 'fullscreenElement', 'fullscreenEnabled', 'fullscreenchange', 'fullscreenerror'],
            // New WebKit
            [
                'webkitRequestFullscreen',
                'webkitExitFullscreen',
                'webkitFullscreenElement',
                'webkitFullscreenEnabled',
                'webkitfullscreenchange',
                'webkitfullscreenerror'
            ],
            // Old WebKit
            [
                'webkitRequestFullScreen',
                'webkitCancelFullScreen',
                'webkitCurrentFullScreenElement',
                'webkitCancelFullScreen',
                'webkitfullscreenchange',
                'webkitfullscreenerror'
            ],
            [
                'mozRequestFullScreen',
                'mozCancelFullScreen',
                'mozFullScreenElement',
                'mozFullScreenEnabled',
                'mozfullscreenchange',
                'mozfullscreenerror'
            ],
            ['msRequestFullscreen', 'msExitFullscreen', 'msFullscreenElement', 'msFullscreenEnabled', 'MSFullscreenChange', 'MSFullscreenError']
        ];
        this.compileNativeAPI();
    }
    compileNativeAPI() {
        const unprefixedMethods = this.methodMap[0];
        const nativeAPI = {};
        for (const methodList of this.methodMap) {
            const exitFullscreenMethod = methodList === null || methodList === void 0 ? void 0 : methodList[1];
            if (exitFullscreenMethod in document) {
                methodList.forEach((method, index) => {
                    nativeAPI[unprefixedMethods[index]] = method;
                });
                this.nativeAPI = nativeAPI;
                return;
            }
        }
    }
    get isEnabled() {
        return Boolean(this.nativeAPI && Boolean(document[this.nativeAPI.fullscreenEnabled]));
    }
    get isFullscreen() {
        return Boolean(this.nativeAPI && document[this.nativeAPI.fullscreenElement]);
    }
    get element() {
        var _a;
        return this.nativeAPI ? (_a = document[this.nativeAPI.fullscreenElement]) !== null && _a !== void 0 ? _a : undefined : undefined;
    }
    on(event, callback) {
        const eventNames = this.eventNameMap[event];
        if (eventNames) {
            /**
             * We listen to all events because at the time of writing we do not have a ssot for managing fullscreen behavoir
             * and as a result 'fullscreenchange' or 'webkitfullscreenchange' is called.
             */
            eventNames.forEach(eventName => document.addEventListener(eventName, callback, false));
        }
    }
    off(event, callback) {
        const eventNames = this.eventNameMap[event];
        if (eventNames) {
            eventNames.forEach(eventName => document.removeEventListener(eventName, callback, false));
        }
    }
}
//# sourceMappingURL=fullscreen.helper.js.map